import { memo } from "react";
import { useTranslation } from "react-i18next";
import { colors, fonts } from "../../../Styles";

export const TablePrefs = memo(({content, tableHeight, popout}: {content:JSX.Element, tableHeight:string, popout:boolean}) => {
  const { t } = useTranslation();
  
  return (
    <div style={{ boxSizing: "border-box", display: "flex", flexDirection: "column", width: "310px", height: tableHeight, minHeight: "300px", backgroundColor: colors.greyPrimary, border: "5px solid " + colors.greySecondary, borderRadius: "10px", overflow: "hidden" }}>
    <div style={{backgroundColor: colors.greySecondary, height: "30px", width: "100%", display: "flex", alignItems: "center", justifyContent: "center", color: colors.greyLightTertiary, ...fonts.header, ...fonts.fontSize3}}>{t("animalPages.animals.tablePreferences", { defaultValue: "Table preferences" })}</div>
    <div style={{ flex: "1", padding: "5px 10px", borderStyle: "solid", borderColor: colors.greyPrimary, borderWidth: "5px 0px", overflowY: "scroll", scrollbarColor: colors.greySecondary+colors.transparent, scrollbarWidth: "thin", height: "100%", maxHeight: popout ? "400px" : undefined}}>
      {content}
    </div>
  </div>)
})